import React from 'react'

import { Container } from "shards-react";



class Clock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            progress: 0
        };
    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            date: new Date(),
            progress: ((this.state.date.getMinutes() * 60 + this.state.date.getSeconds()) % 900)/900*100, 
            min: Math.floor(((3600-(this.state.date.getMinutes() * 60 + this.state.date.getSeconds()))%900) /60),
            sec: ((3600-(this.state.date.getMinutes() * 60 + this.state.date.getSeconds()))%900) %60
        });
    }

    render() {
        return (
            <Container style={{ maxWidth: '100%' }}>
                <div className="progress-wrapper px-3" >
                    <span className="progress-label text-white" style={{ fontSize: "1.2rem" }}>Live data is downloaded to the database every 15 minutes. 
                                                     If you wish to load new data into the charts, 
                                                     click on your browser refresh button.</span>
                     
                                                    

                </div >
                
                <div className="progress-wrapper px-3" >
                    <span className="progress-label text-white" style={{ fontSize: "1.2rem" }}>Time left until next download: {this.state.min} minutes, {this.state.sec} seconds. (All Times UTC)</span>
           
                </div >

            </Container>
        );
    }
}

export default Clock
